module.exports = __webpack_public_path__ + "src/assets/images/supported-browsers.svg";